module.exports = __webpack_public_path__ + "img/logo.fdfe8100.png";